import apiFetch from '../axios/config';
import { formatUtcDateTimeAsSaoPaulo } from '../utils/formatTime';

/**
 * CHAN-70: histórico de entregas de webhook (API da CHAN-69).
 * Autenticação pela credencial da entidade, como as outras telas do painel.
 */

export const WEBHOOK_PAGE_SIZE = 50;

const DATE_FIELDS = ['sent_at', 'last_attempt_at', 'created_at'];

/**
 * O interceptor global reescreve QUALQUER chave `*_at` da resposta, inclusive dentro do
 * `payload` enviado ao cliente (que tem que aparecer exatamente como foi enviado). Por isso
 * a resposta vem como texto (o interceptor pula) e só as datas do próprio item são formatadas.
 */
function parseDelivery(item) {
  const out = { ...item };
  DATE_FIELDS.forEach((k) => {
    if (out[k]) out[k] = formatUtcDateTimeAsSaoPaulo(out[k]) || out[k];
  });
  return out;
}

function parseBody(data) {
  return typeof data === 'string' ? JSON.parse(data) : data;
}

/**
 * Lista as entregas de UM envelope ou de UM lote, da mais recente para a mais antiga.
 * @param {string} apiKey - api_key da entidade
 * @param {{ envelopeKey?: string, batchEnvelopeKey?: string, cursor?: string }} filtro
 * @returns {Promise<{ items: Array, next_cursor: string|null }>}
 */
export async function listWebhookDeliveries(apiKey, { envelopeKey, batchEnvelopeKey, cursor } = {}) {
  const params = { limit: WEBHOOK_PAGE_SIZE };
  if (envelopeKey) params.envelope_key = envelopeKey;
  if (batchEnvelopeKey) params.batch_envelope_key = batchEnvelopeKey;
  if (cursor) params.cursor = cursor;
  const response = await apiFetch.get('/webhook/outbox', {
    headers: { Authorization: `${apiKey}` },
    params,
    responseType: 'text',
  });
  const data = parseBody(response.data);
  return { ...data, items: (data.items || []).map(parseDelivery) };
}

/**
 * Detalhe de uma entrega (payload enviado e resposta do cliente, já truncada a 2 KB pela API).
 */
export async function getWebhookDelivery(apiKey, outboxKey) {
  const response = await apiFetch.get(`/webhook/outbox/${encodeURIComponent(outboxKey)}`, {
    headers: { Authorization: `${apiKey}` },
    responseType: 'text',
  });
  return parseDelivery(parseBody(response.data));
}
